import Cookies from 'js-cookie'

const TokenKey = process.env.VUE_APP_APPLICATION_CODE + 'ticketCookie'

const site = 'site'

const DOMAIN = window.location.host.replace(/^([A-z0-9])+/, '')

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  Cookies.set(TokenKey, token)
  return Cookies.set(TokenKey, token, { domain: DOMAIN })
}

export function removeToken() {
  Cookies.remove(TokenKey)
  return Cookies.remove(TokenKey, { domain: DOMAIN })
}

export function getSite() {
  return Cookies.get(site)
}
